import deviceTypes from '../../util/deviceTypes';
import { getUserAgent } from '../../util/userAgent';
import { UserAgent } from './userAgentTypes';

export const getDeviceInfoObject = (
  deviceType: String,
  orientation: String
) => ({
  isDesktop: deviceType === deviceTypes.DESKTOP,
  isMobile: deviceType === deviceTypes.MOBILE,
  isTablet: deviceType === deviceTypes.TABLET,
  isPortrait: orientation === 'portrait',
  isLandscape: orientation === 'landscape',
});

const getDefaultState = (): UserAgent => {
  const { deviceType, orientation } = getUserAgent();

  return {
    deviceType,
    orientation,
    ...getDeviceInfoObject(deviceType, orientation),
  };
};

export default getDefaultState();
